import { Link } from '@tanstack/react-router';

/**
 * Free-tier play counter in the browse top bar — now an actionable link to
 * /subscribe (Spec 02 — C4). Visible only to signed-in free members (the caller
 * decides visibility; members never see it). Above the low-balance threshold it
 * stays a quiet "N/M free" counter; at one play left (used >= limit - 1) it
 * switches to an emphasized oxblood "Join" nudge. Plays surface only — reads get
 * no pill (the per-article wall from Spec 01 carries the reads signal).
 */
export function FreePlaysPill({ used, limit }: { used: number; limit: number }) {
  const remaining = Math.max(limit - used, 0);
  const plural = remaining === 1 ? '' : 's';

  // Low-balance nudge: one play left (or none) → emphasized conversion state.
  if (used >= limit - 1) {
    return (
      <Link
        to="/subscribe"
        aria-label={`${remaining} free play${plural} left — join for unlimited`}
        className="rounded-full border border-oxblood-live bg-oxblood-live/15 px-3 py-1 font-sans text-xs font-medium text-oxblood-live transition hover:bg-oxblood-live/25"
      >
        {remaining} play{plural} left — Join
      </Link>
    );
  }

  return (
    <Link
      to="/subscribe"
      aria-label={`${remaining} of ${limit} free plays left — join for unlimited`}
      className="rounded-full border border-video-line-strong px-3 py-1 font-sans text-xs text-video-text-muted transition hover:text-video-text"
    >
      {used}/{limit} free
    </Link>
  );
}
